<h2 class="title-header" mat-dialog-title *ngIf="!program" automation-locator="add-new-program-header">Add New Program</h2>
<h2 class="title-header" mat-dialog-title *ngIf="program" automation-locator="add-new-program-header">{{program?.name}} Edit</h2>

<mat-dialog-content class="mat-typography" [formGroup]="programForm">
  <div class="flex flex-wrap" style="gap: 20px">
    <mat-form-field>
      <mat-label>Program Name</mat-label>
      <input matInput required formControlName="name" automation-locator="program-name-textbox">
      <mat-error *ngIf="programForm.get('name').invalid">
        <div *ngIf="programForm.get('name').errors.required">
          Name is required.
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Program Type</mat-label>
      <mat-select required formControlName="programType" [disabled]="program?.id != null" automation-locator="program-type-drop-down-menu">
        <mat-option [value]="null">None Selected</mat-option>
        <mat-option *ngFor="let programType of programTypes" [value]="programType.key">
          {{programType.value}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="programForm.get('programType').invalid">
        <div *ngIf="programForm.get('programType').errors.required">
          Program type is required
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Notification Timeframe</mat-label>
      <input matInput type="number" formControlName="notificationTimeframe" automation-locator="notification-timeframe-textbox">
      <mat-error *ngIf="programForm.get('notificationTimeframe').invalid">
        <div *ngIf="programForm.get('notificationTimeframe').errors.required">
          Notification timeframe is required.
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Market Auction</mat-label>
      <mat-select required formControlName="marketAuction" placeholder="Choose an option" automation-locator="market-auction">
        <mat-option [value]="null">None Selected</mat-option>
        <mat-option value="{{true}}">Yes</mat-option>
        <mat-option value="{{false}}">No</mat-option>
      </mat-select>
      <mat-error *ngIf="programForm.get('marketAuction').invalid">
        <div *ngIf="programForm.get('marketAuction').errors.required">
          Market Auction is required.
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Penalty</mat-label>
      <input matInput type="number" formControlName="penalty" automation-locator="penalty-textbox">
      <mat-error *ngIf="programForm.get('penalty').invalid">
        <div *ngIf="programForm.get('penalty').errors.required">
          Penalty is required
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Point of Measurement</mat-label>
      <mat-select required formControlName="pointOfMeasurement" automation-locator="point-of-measurement">
        <mat-option [value]="null">None Selected</mat-option>
        <mat-option *ngFor="let point of pointOfMeasurement" [value]="point.key">
          {{point.value}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="programForm.get('pointOfMeasurement').invalid">
        <div *ngIf="programForm.get('pointOfMeasurement').errors.required">
          Point of Measurement is required.
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Performance Target</mat-label>
      <mat-select required formControlName="performanceTarget" automation-locator="performance-target">
        <mat-option [value]="null">None Selected</mat-option>
        <mat-option *ngFor="let target of performanceTarget" [value]="target.key">
          {{target.value}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="programForm.get('performanceTarget').invalid">
        <div *ngIf="programForm.get('performanceTarget').errors.required">
          Performance Target is required.
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Default Incentive</mat-label>
      <input matInput required type="number" formControlName="incentive" automation-locator="default-incentive-textbox">
      <mat-error *ngIf="programForm.get('incentive').invalid">
        <div *ngIf="programForm.get('incentive').errors.required">
          Default Incentive is required
        </div>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Nominated kW</mat-label>
      <input matInput type="number" formControlName="nominatedKw" automation-locator="nominated-kw-textbox">
      <mat-error *ngIf="programForm.get('nominatedKw').invalid">
        <div *ngIf="programForm.get('nominatedKw').errors.required">
          Nominated kW is required
        </div>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="flex flex-col">
    <mat-checkbox formControlName="forwardStats" automation-locator="forward-statistics-checkbox">Forward Statistics</mat-checkbox>
    <mat-checkbox formControlName="forceMaxDispatch" automation-locator="force-max-dispatch-checkbox">Force Max Dispatch</mat-checkbox>
    <em automation-locator="nominated-kw-note-text" style="margin-left: 1rem">Nominated kW  (Positive: Charge / Negative: Discharge)</em>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="warn" (click)="close()" automation-locator="program-module-cancel-button">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!programForm.valid" automation-locator="program-module-save-button">Save</button>
</mat-dialog-actions>
